<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> build_circle </v-icon>
      <span :class="ui.textHeadline"> Technical </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Technical objects management, maintenance and processes.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <v-btn :color="ui.btnColor" flat dark :to="'/companydashtechnical'"
        v-if="this.licenceOK && this.userOK">
          <v-icon left>
            info
          </v-icon>
          Detail
        </v-btn>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="!this.licenceOK || !this.userOK">
          <v-icon left>
            info
          </v-icon>
          Restricted Use
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
export default {
  mixins: [apptheme, licenceFunctions, adminFunctions],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser"])
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
